<template>
    <div class="transaction">
      <div class="case-title-box">
        <div class="case-title">
          <img class="case-title_icon" src="@/assets/images/icon_hsfl_.png" alt />
          <div class="case-title_max">回收营销加价设置</div>
        </div>
        <div style="font-size: 14px;">
         <span style="margin-right: 20px;">最近修改：{{configDATA.lastUpdateBy}}</span><span>{{configDATA.lastUpdateTime}} </span>
        </div>
      </div>
      <div class="case-title" style="font-size: 14px;">
          <div style="margin-right: 5px;">营销加价计算</div>
          <div @click="seeSampleImage" style="cursor: pointer;text-decoration: underline;color: #0981ff;">查看示例</div>
      </div>
      <div class="center_text">
          <div style="margin-bottom: 10px;">回收营销加价=（当前顾客显示报价/1+加价比例）*加价比例，向上取整</div> 
          <div>本机估价=顾客显示报价-回收营销加价</div> 
      </div>
      <div class="case-title-box"  style="font-size: 14px;margin-bottom: 20px;">
          <div>营销加价规则</div>
        <div>
          <el-button icon="el-icon-plus" type="primary" size="small" @click="$refs['PricesetRuleDia'].open()">添加规则</el-button>
        </div>
      </div>
      <el-table border :data="list">
        <el-table-column type="index" width="100" align="center" label="序号">
        </el-table-column>
        <el-table-column
          align="center"
          label="最高显示价"
          prop="region"
        >
          <template slot-scope="{ row }">
            <span>{{ row.priceMin }}≤区间＜{{ row.priceMax }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="加价比例"
          prop="upScale"
        >
          <template slot-scope="{ row }">
            <span>{{ row.upScale }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="加价上限" prop="upLimit" align="center">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="$refs['PricesetRuleDia'].open(scope.row)"
              type="primary"
              >编辑</el-button
            >
            <el-button
              size="small"
              @click="delItem(scope.$index)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" style="margin-top:30px" @click="command = '';usedDialogVisible = true">保存</el-button>
  
      <PricesetRuleDia ref="PricesetRuleDia" @confirm="ruleChangeHandler" />
      <el-dialog title="提示" :visible.sync="usedDialogVisible" :close-on-click-modal="false" width="500px">
        <div style="font-size: 16px; color: #666666; line-height: 50px;">
          <div style="text-align: center;">是否确认保存营销加价配置？</div>
        </div>
        <div class="command">
          <div style="width: 88px;">动态口令：</div>
          <el-input v-model="command" placeholder="请输入谷歌动态口令"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click.native="usedDialogVisible = false">取消</el-button>
          <el-button type="primary" @click.native="saveconfig">确定</el-button>
        </span>
      </el-dialog>
      <el-image-viewer v-if="showViewer" :on-close="()=>{showViewer = false}" :url-list="imgList" />
    </div>
  </template>
  
  <script>
  import ElImageViewer from "element-ui/packages/image/src/image-viewer";
  import _api from "@/utils/request";
  import PricesetRuleDia from './dialog/PricesetRuleDia.vue';
  export default {
    components: { PricesetRuleDia ,ElImageViewer},
    data() {
      return {
        list: [],
        showViewer:false,
        imgList: ['https://img.fanxinghuishou.cn/20250929/830087321.png'],
        command: '',
        usedDialogVisible: false,
        configDATA:{}
      }
    },
    created() {
      this.getConfig()
    },
    methods: {
     // 查看示例图大图
     seeSampleImage(row) {
      this.showViewer = true;
    },
      getConfig() {
        _api.getmarketingMarkConfig().then(res => {
          this.configDATA=res.data
          this.list = res.data.list
        })
      },
      ruleChangeHandler(type, ruleItem) {
        if (type == 'add') {
          this.list.push({ ...ruleItem, _t: Math.random()})
        } else {
          const { id, _t } = ruleItem
          const itemIndex = this.list.findIndex(item => {
            if (id) return item.id === id
            return _t === item._t
          })
          this.$set(this.list, itemIndex, ruleItem)
        }
      },
      delItem(i) {
        this.list.splice(i, 1)
      },
      saveconfig() {
        _api.savemarketingMarkConfig({
          command: this.command,
          list: this.list
        }).then(() => {
          this.$message.success('保存成功！')
          this.usedDialogVisible = false
          this.getConfig()
        })
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .center_text{
    color: #0981ff;
    font-size: 14px;
    background: #f5f6fa;
    border-radius: 10px;
    padding: 10px;
    margin: 10px 0;
    width: 100%;
    box-sizing: border-box;
  }
  .transaction {
    padding: 0 20px;
  }
  .case-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .case-title {
    // padding: 0 20px;
    display: flex;
    align-items: center;
    //width: 100%;
  
    .case-title_icon {
      width: 20px;
      height: 20px;
      margin-right: 3px;
    }
  
    .case-title_max {
      font-size: 18px;
      font-family: FZLanTingHei-B-GBK;
      font-weight: bold;
      color: #333333;
      line-height: 41px;
    }
  
    .case-title_min {
      margin-left: 5px;
      width: 500px;
      height: 13px;
      font-size: 12px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      color: #ff687b;
      line-height: 45px;
    }
  }
  .command {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .command .el-input {
    width: 80%;
  }
  </style>